import Vue from 'vue'
import Vuex from 'vuex'
import user from '@/store/modules/user'
import getters from '@/store/getters'
import pageStore from '@/store/modules/pageStore'
import userAddress from '@/store/modules/userAddress'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    pageStore,
    userAddress
  },
  getters
})

export default store